import { getErrorMsgFromError } from '../error-msg';
import { DEFAULT_FORMAT_RESPONSE } from '../constant';
export default (function (axiosInstance, globalConfig) {
    var logConfig = (globalConfig || {}).logConfig;
    var logger = (logConfig || {}).logger;
    return function (config) {
        var formatResponse = config.formatResponse || DEFAULT_FORMAT_RESPONSE;
        return axiosInstance.request(config)
            .catch(function (error) {
            if (!error.isAxiosError) {
                if (logger && logger.collect) {
                    logger.collect('CUSTOM', 'ESHOP_REQUEST_EXCEPTION', {
                        message: (error && error.message) || '非axios错误',
                        config: config,
                    });
                }
            }
            // 先处理网络错误
            var _a = error || {}, code = _a.code, response = _a.response;
            var status = (response || {}).status;
            var error_msg = '网络错误';
            try {
                error_msg = getErrorMsgFromError(error);
            }
            catch (e) {
                if (logger && logger.collect) {
                    logger.collect('CUSTOM', 'ESHOP_REQUEST_ERROR_MSG', {
                        message: (e && e.message) || '从error中获取错误信息失败',
                        config: config,
                        error: error,
                    });
                }
            }
            if (response && response.config) {
                response.config.logConfig = {};
            }
            return Promise.reject({
                response: response,
                result: code || status,
                error_msg: error_msg,
            });
        })
            .then(function (response) {
            if (response && response.config) {
                response.config.logConfig = {};
            }
            return formatResponse(response);
        });
    };
});
//# sourceMappingURL=createBaseRequest.js.map